import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  AfterViewInit,
  effect,
} from "@angular/core";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { WorkflowUpdatesDto } from "../../../core/models/project-workflow/workflowUpdatesDto";
import { WorkflowUpdatesResponseDto } from "../../../core/models/project-workflow/workflowUpdatesResponseDto";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { SignalRService } from "../../../core/services/signal-r.service";
import { CommonModule } from "@angular/common";
import { DrawerModule } from "primeng/drawer";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "jni-add-workflow-updates",
  templateUrl: "./add-workflow-updates.component.html",
  styleUrls: ["./add-workflow-updates.component.scss"],
  imports: [CommonModule, DrawerModule, FormsModule],
})
export class AddWorkflowUpdatesComponent implements AfterViewInit {
  @Input() display!: boolean;
  @Input() projectWorkflowId = 0;
  @Input() isWorkflowOwners = true;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() closeSidebar = new EventEmitter();
  @ViewChild("updatesContainer") updatesContainer!: ElementRef;

  update = "";
  workflowUpdatesList = [] as WorkflowUpdatesResponseDto[];

  constructor(
    private _productionWorkflowService: ProjectWorkflowService,
    private _toastr: JniToastrService,
    private _signalRService: SignalRService
  ) {
    effect(() => {
      const update = this._signalRService.updates();
      if (update) {
        this.getWorkflowUpdatesList();
      }
    });
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  postWorkflowUpdate() {
    const payload = {} as WorkflowUpdatesDto;
    if (!this.update || this.update === "") {
      this._toastr.error("Error", "Enter a message to post Updates");
      return;
    }
    payload.message = this.update;
    payload.projectWorkFlowId = this.projectWorkflowId;
    this._productionWorkflowService.postWorkflowUpdates(payload).subscribe({
      next: res => {
        if (res?.status !== "Success") {
          this._toastr.error("Error", "Update was not saved");
        }
        this.update = "";
        this.scrollToBottom();
        this.getWorkflowUpdatesList();
      },
      error: res => {
        this._toastr.error("Error", res.message);
      },
    });
  }

  getWorkflowUpdatesList() {
    this.workflowUpdatesList = [];
    this._productionWorkflowService
      .getWorkflowUpdatesList(this.projectWorkflowId)
      .subscribe({
        next: res => {
          if (res?.totalRecords && res.totalRecords > 0) {
            this.workflowUpdatesList = res.data;
            setTimeout(() => this.scrollToBottom(), 0);
          }
        },
        error: res => {
          this._toastr.error("Error", res.message);
        },
      });
  }

  scrollToBottom(): void {
    this.updatesContainer.nativeElement.scrollTop =
      this.updatesContainer.nativeElement.scrollHeight;
  }

  onHide() {
    this.displayChange.emit(false);
    this.closeSidebarModel();
  }

  closeSidebarModel() {
    this.closeSidebar.emit();
  }
}
